import React from "react";

export const PageLoader = () => {
  const loadingImg = "https://cdn.auth0.com/blog/hello-auth0/loader.svg";

  return (
    <>
      {/* Desktop loader - hidden on mobile */}
      <div className="hidden md:block pt-8">
        <div className="loader">
          <img src={loadingImg} alt="Loading..." />
        </div>
      </div>

      {/* Mobile loader - pulsing bar spanning the screen */}
      <div className="md:hidden w-full px-4 py-8">
        <div className="w-full h-4 bg-white rounded overflow-hidden">
          <div className="pulsing-bar h-full w-full rounded"></div>
        </div>
      </div>
    </>
  );
};
